import { useEffect, useContext } from 'react'
import PropTypes from 'prop-types'

import { NavigationContext } from '../../context/NavigationContext'
import { runCmpScript } from './cmpScript'
const ConsentManager = ({ cmpid }) => {
  const navigationContext = useContext(NavigationContext)

  useEffect(() => {
    // This adds the ConsentManager script.
    // See this page for all the methods provided by their api: https://help.consentmanager.net/books/cmp/page/javascript-api
    runCmpScript(cmpid)
    navigationContext.setConsentManagerLoaded(true)
  }, [cmpid])

  useEffect(() => {
    // This listens for consent changes and updates navigation context consent state accordingly.
    if (typeof __cmp !== 'undefined') {
      // eslint-disable-next-line no-undef
      __cmp(
        'addEventListener',
        [
          'consent',
          () => {
            // eslint-disable-next-line no-undef
            const consentData = __cmp('getCMPData')
            navigationContext.updateCookiesConsent(consentData)
          },
          false
        ],
        null
      )
    }
  }, [cmpid])

  return null
}

ConsentManager.propTypes = {
  cmpid: PropTypes.string.isRequired
}

export default ConsentManager
